import { AppServiceFactory } from '@modules/app/service/AppServiceFactory';
import { IAppService } from '@modules/app/service/IAppService';
import { HistoryServiceFactory } from '@modules/canvas/services/history/HistoryServiceFactory';
import { IHistoryService } from '@modules/canvas/services/history/IHistoryService';

import { IKeyMap } from './IKeyMap';
import { Shortcut } from '../types';

export class PropertyPanelKeyMap implements IKeyMap {
  private appSvc: IAppService;
  private historySvc: IHistoryService;

  public constructor() {
    this.appSvc = AppServiceFactory.getInstance().createAppService();
    this.historySvc = HistoryServiceFactory.getInstance().createHistoryService();
  }

  handleKeyPress(shortcut: Shortcut): void {
    switch (shortcut.code) {
      case 'KeyS': {
        if (shortcut.ctrl) {
          this.appSvc.finalizeRevision();
          break;
        }

        break;
      }

      case 'KeyZ': {
        if (shortcut.ctrl) {
          this.historySvc.undo();
          break;
        }

        break;
      }

      case 'KeyY': {
        if (shortcut.ctrl) {
          this.historySvc.redo();
          break;
        }

        break;
      }

      default:
        break;
    }
  }
}
